module.exports = __webpack_public_path__ + "img/3.3fa70d9b.png";